const accessibilityGradeIcons = (value) => {
  switch (value) {
  case 'accessible':
    return 'fa fa-check text-success'
  case 'partially_accessible':
    return 'fa fa-exclamation-triangle text-warning'
  case 'not_accessible':
    return 'fas fa-times text-danger'
  }
}

const tourTypeColors = (value) => {
  switch (value) {
  case 'regular_group':
    return 'bg-light text-dark'
  case 'small_group':
    return 'bg-success text-white'
  case 'private_group':
    return 'bg-danger text-white'
  case 'tailor_made':
    return 'bg-light text-dark'
  case 'hop_on_hop_off':
    return 'bg-warning text-dark'
  case 'self_guided':
    return 'bg-light text-dark'
  case 'pack':
    return 'bg-light text-dark'
  }
}

export {accessibilityGradeIcons, tourTypeColors}
